export const ZOOM_JOIN_URL =
  "https://us06web.zoom.us/j/88521063224?pwd=ALgq2NhVYI33IhGmueFCH4AL9JV4VZ.1";
export const ZOOM_MEETING_ID = "885 2106 3224";
export const ZOOM_PASSCODE = "456789";
